<div class="container-fluid">
   <div class="row">
      <app-mobile-header></app-mobile-header>
   </div>
    <div class="row" >  
      <!-- <div class="col-2 fixed-top bg-light side-bar  p-0" >
        <app-siderbar></app-siderbar>
       </div>   -->

        <div class="col bg-light p-0" >
            <router-outlet></router-outlet>
            </div>
     
    </div>
  </div>
